import React, { useMemo, useState } from "react";
import { Box, Button } from "zmp-ui";
import { ProductItem } from "../../component/product/item";
import { CART_ICONS } from "./interfaces/icon";
import {useCartProduct} from "./hooks/useCartProduct";

export function ListProduct({ items, limit, quantityChange, onDelete, mode }) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const {func} = useCartProduct()
  const collapsedItems = useMemo(() => {
    return items.slice(0, limit);
  }, [items, limit]);

  return (
    <Box className="bg-background rounded-xl">
      <Box
        // className={`bg-background grid ${
        //window.innerWidth < 768 ? "grid-cols-1" : "grid-cols-2"
        // } gap-4`}
        className={`bg-background`}
      >
        {(isCollapsed ? collapsedItems : items).map((item, i, list) => (
          <ProductItem
            list={list}
            product={item}
            onAmountChange={quantityChange}
            onDelete={onDelete}
            page="cart"
            mode={mode}
            updateProductOfOrder={func.updateProductOfOrder}
          />
        ))}
      </Box>
      {isCollapsed && collapsedItems.length < items.length ? (
        <Box className="p-2">
          <Button
            onClick={() => setIsCollapsed(false)}
            fullWidth
            suffixIcon={<div>{CART_ICONS.down}</div>}
            variant="tertiary"
            type="neutral"
            style={{ color: "#0075FF", fontSize: "15px", fontWeight: "500" }}
          >
            Hiện thêm {items.length - 3} sản phẩm
          </Button>
        </Box>
      ) : items.length > 3 ? (
        <Box className="p-2">
          <Button
            onClick={() => setIsCollapsed(true)}
            fullWidth
            suffixIcon={<div>{CART_ICONS.up}</div>}
            variant="tertiary"
            type="neutral"
            style={{ color: "#0075FF", fontSize: "15px", fontWeight: "500" }}
          >
            Thu gọn
          </Button>
        </Box>
      ) : (
        <Box className="w-full h-4"></Box>
      )}
    </Box>
  );
}
